import React, { useEffect, useState } from 'react'
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import ListItemText from '@material-ui/core/ListItemText'
import ListItem from '@material-ui/core/ListItem'
import List from '@material-ui/core/List'
import Divider from '@material-ui/core/Divider'
import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import IconButton from '@material-ui/core/IconButton'
import Typography from '@material-ui/core/Typography'
import CloseIcon from '@material-ui/icons/Close'
import Slide from '@material-ui/core/Slide'
// import { TransitionProps } from '@material-ui/core/transitions';
import Accordion from '@material-ui/core/Accordion'
import AccordionDetails from '@material-ui/core/AccordionDetails'
import AccordionSummary from '@material-ui/core/AccordionSummary'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import Autocomplete from '@material-ui/lab/Autocomplete'
import Icon from '@material-ui/core/Icon'
import Switch from '@material-ui/core/Switch'

import { CsvToHtmlTable } from 'react-csv-to-table'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogActions from '@material-ui/core/DialogActions'
import DescriptionIcon from '@material-ui/icons/Description'

import GetAppIcon from '@material-ui/icons/GetApp'

import {
  loadProgrammesData,
  updateCsvAction,
  loadRolesData,
  updateSetupProgress,
  updateSummeryUserEmailList,
  loadSectionData,
  updateSectionUserData,
  clearSummeryCourses,
  postEnrollmentsData
} from '../../actions'

import { connect } from 'react-redux'
import TextField from '@material-ui/core/TextField'

import Grid from '@material-ui/core/Grid'
import Radio from '@material-ui/core/Radio'
import RadioGroup from '@material-ui/core/RadioGroup'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import FormLabel from '@material-ui/core/FormLabel'
import BrowserStore from 'store'

import LinearProgress from '@material-ui/core/LinearProgress'

import {
  updateSectionSISID,
  createGroupCategory,
  loadGroupCategories,
  getSISImportStatus
} from '../../services/saga'
import Alert from '@material-ui/lab/Alert'

import Paper from '@material-ui/core/Paper'
import OutlinedInput from '@material-ui/core/OutlinedInput'
import FormControl from '@material-ui/core/FormControl'
import InputLabel from '@material-ui/core/InputLabel'
import MenuItem from '@material-ui/core/MenuItem'
import Select from '@material-ui/core/Select'
import { unstable_renderSubtreeIntoContainer } from 'react-dom'
import Tabs from '@material-ui/core/Tabs'
import Tab from '@material-ui/core/Tab'

import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableContainer from '@material-ui/core/TableContainer'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import CircularProgress from '@material-ui/core/CircularProgress'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    appBar: {
      position: 'relative'
    },
    title: {
      marginLeft: theme.spacing(2),
      flex: 1
    },

    theme: {
      background: '#4caf500d'
    },

    root: {
      width: '100%'
    },
    heading: {
      fontSize: theme.typography.pxToRem(15),
      flexBasis: '33.33%',
      flexShrink: 0
    },
    secondaryHeading: {
      fontSize: theme.typography.pxToRem(15),
      color: theme.palette.text.secondary
    },
    paper: {
      padding: theme.spacing(2),
      textAlign: 'center',
      color: theme.palette.text.secondary
    },

    pullRight: {
      textAlign: 'right'
    },

    pullLeft: {
      textAlign: 'left'
    }
  })
)

const Transition = React.forwardRef(function Transition(
  props: { children?: React.ReactElement },
  ref: React.Ref<unknown>
) {
  return <Slide direction='up' ref={ref} {...props} />
})

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`
  }
}

function TabPanel(props) {
  const { children, value, index, ...other } = props

  return (
    <div
      role='tabpanel'
      hidden={value !== index}
      id={`wrapped-tabpanel-${index}`}
      aria-labelledby={`wrapped-tab-${index}`}
      {...other}
    >
      {children}
    </div>
  )
}

function createData(name, downloadLink) {
  return { name, downloadLink }
}

const csvTemplates = [
  createData('Group Enrollment Csv', 'Group-User-Enrollment-Template.csv')
]

function FullScreenDialog(props) {
  const classes = useStyles()

  const downloadPath = process.env.REACT_APP_APP_URL

  const {
    fullPageModel,
    setFullPageModel,
    selectedCourse,
    rolesData,
    csvActionType,
    loadRolesData,
    loadSectionData,
    courseSectionData,
    courseSectionUserData,
    updateSectionUserData,
    selectedCoursesList,
    clearSummeryCourse,
    postEnrollmentsData,
    sis_status
  } = props

  const [title, setTitle] = useState('')
  const [subTitle, setSubTitle] = useState('')

  let roles = [[{ id: 0, label: 'Loading..' }]]

  let inputValueRole = ''

  let includeRoles = []

  const [expanded, setExpanded] = React.useState(false)

  const [courseSection, setCourseSection] = useState([])

  const [groupDetails, setGroupDetails] = useState([])

  const [optionRoles, setOptionRoles] = useState([])

  const [isLoading, setIsLoading] = useState(true)

  const [checkSectionSIS, setCheckSectionSIS] = useState(false)

  const [sectionSISUpdated, SetSectionSISUpdated] = useState(false)

  const browserData = BrowserStore.get('inseadCanvasAdmin')

  ////

  const [enableReviewGroupCategory, setEnableReviewGroupCategory] =
    useState(true)

  const [enableReviewCsv, setEnableReviewCsv] = useState(false)

  const [enableTemplateCsv, setEnableTemplateCsv] = useState(false)

  const [groupName, setGroupName] = useState('')
  const [sectionNames, setSectionNames] = useState([])
  const [groupCount, setGroupCount] = useState([])

  const [groupCountEnd, setGroupCountEnd] = useState([])

  const [csvData, setCSVData] = useState([])

  const [groupCreated, setGroupCreated] = useState('NEW')

  const [groupCategories, setGroupCategories] = useState([])
  const [selectedGroupName, setSelectedGroupName] = useState('')
  // const   radioDefaultValue = csvActionType;

  const [dynamicGroupCategoryCount, setDynamicGroupCategoryCount] = useState([
    1
  ])

  const generateSelectOptionCount = 50

  useEffect(() => {
    if (selectedCourse.name) {
      setTitle(`${selectedCourse.name}`)
      setSubTitle(
        `SIS: ${selectedCourse.sis_course_id} - Term: ${selectedCourse.term.name}`
      )

      // let userTextData = courseSectionUserData.data.filter((data, i) => data[selectedCourse.id]);

      // if (userTextData.length !== 0) {

      //   setGroupDetails(userTextData)
      // }

      // let sectionDataLoaded = courseSectionData.data.filter((data, i) => data[selectedCourse.id])

      // if (sectionDataLoaded.length === 0) {
      //   // loadSectionData(selectedCourse.id);
      //   // setCheckSectionSIS(true)
      // } else {
      //   // setCourseSection(sectionDataLoaded[0][selectedCourse.id]);

      //   // setCheckSectionSIS(true)

      // }

      loadCategories()
    }
  }, [selectedCourse])

  const loadCategories = () => {
    let payload = {
      courseID: selectedCourse.id
    }

    loadGroupCategories(payload).then((data) => {
      let dataSet = data.data

      setGroupCategories(dataSet)
    })
  }

  const handleClickOpen = () => {}

  useEffect(() => {}, [selectedCoursesList])

  const clearState = () => {
    setFullPageModel(false)
    setCourseSection([])
    setGroupDetails([])

    setFileUploaded(false)
    setProgress(0)
    setTextStatus('NO_DATA')
    setCsvErrors([])
    setCSVData([])
    setGroupCount([])
    setGroupCountEnd([])
    setGroupName('')
    setDynamicGroupCategoryCount([1])
    setGroupCreated('NEW')
    setSelectedGroupName('')
    setSectionNames([])
    setGroupCategories([])
    setUploadCSVData([])

    setEnableReviewCsv(true)
    setEnableReviewGroupCategory(true)

    setDisableCreateGroups(false)
  }

  const handleClose = () => {
    clearState()
  }

  const handleSave = () => {
    clearState()
  }

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false)
  }

  const onChangeGroupName = (event) => {
    setGroupName(event.target.value)
  }

  const onChangeSectionNames = (event, key) => {
    let group = sectionNames
    group[key - 1] = event.target.value
    setSectionNames(group)
    buildCreateCategoryCSV()
  }

  const onGroupCount = (event, key) => {
    let group = groupCount
    let findKey = key.replace('select', '')
    findKey = parseInt(findKey) - 1

    group[findKey] = event.target.value

    setGroupCount(group)
    buildCreateCategoryCSV()
  }

  const onGroupCountEnd = (event, key) => {
    let group = groupCountEnd
    let findKey = key.replace('select-end', '')
    findKey = parseInt(findKey) - 1

    group[findKey] = event.target.value

    setGroupCountEnd(group)
    buildCreateCategoryCSV()
  }

  const onClickCreateGroupCategory = () => {
    //ERROR_NAME

    let createdGroupNames = groupCategories.map((item) =>
      item.name.toLowerCase()
    )

    let finalGroupName = groupName.trim()

    if (createdGroupNames.includes(finalGroupName.toLowerCase())) {
      setGroupCreated('ERROR_NAME')
      return false
    }

    setGroupCreated('CREATING')

    let groupID = finalGroupName.replace(' ', '_')

    let payload = {
      courseID: selectedCourse.id,
      payload: {
        name: finalGroupName,
        sis_group_category_id: `${selectedCourse.sis_course_id}_${groupID}`
      }
    }

    createGroupCategory(payload).then((data) => {
      setGroupCreated('CREATED')
    })
  }

  const onChangeGroupCategory = (event) => {
    setGroupCreated('NEW')
    setGroupName(event.target.value)
  }

  useEffect(() => {
    loadCategories()
  }, [groupCreated])

  useEffect(() => {
    buildCreateCategoryCSV()
  }, [selectedGroupName])

  const onChangeSelectedGroupName = (event, value) => {
    if (value !== null) {
      if (value.sis_group_category_id != null) {
        setSelectedGroupName(value.sis_group_category_id)
      }
    }
  }

  const onClickGroupElementRemove = () => {
    // this means, when we delete a empty section, delete only section
    // without previous section data
    if (dynamicGroupCategoryCount.length !== groupCount.length) {
      setDynamicGroupCategoryCount(
        dynamicGroupCategoryCount.splice(
          0,
          dynamicGroupCategoryCount.length - 1
        )
      )
      buildCreateCategoryCSV()
      return false
    }

    groupCount.pop()
    sectionNames.pop()

    setGroupCount(groupCount)
    setSectionNames(sectionNames)

    setDynamicGroupCategoryCount(
      dynamicGroupCategoryCount.splice(0, dynamicGroupCategoryCount.length - 1)
    )
    buildCreateCategoryCSV()
  }

  const onClickGroupElementCreate = () => {
    setDynamicGroupCategoryCount(
      dynamicGroupCategoryCount.concat(dynamicGroupCategoryCount.length + 1)
    )
    buildCreateCategoryCSV()
  }

  const [dialogOpenEnroll, setDialogOpenEnroll] = useState(false)

  const [dialogOpenCreateGroups, setDialogOpenCreateGroups] = useState(false)
  const [disableCreateGroups, setDisableCreateGroups] = useState(false)

  const [confirmCreateGroups, setConfirmCreateGroups] = useState(false)
  const [confirmEnrollUsers, setConfirmEnrollUsers] = useState(false)

  const dialogCreateOnClose = () => {
    setDialogOpenCreateGroups(false)
    setConfirmCreateGroups(false)
    setProgress(0)
    setCsvErrors([])
    setFileUploaded(false)
    setTextStatus('')
  }

  const dialogEnrollOnClose = () => {
    setDialogOpenEnroll(false)
    setConfirmEnrollUsers(false)
  }

  const dialogEnrollOnConfirm = () => {
    setConfirmEnrollUsers(true)
    postEnrollmentsData(uploadCSVData)
  }

  const dialogCreateOnConfirm = () => {
    let newArr = ['group_category_id', 'group_id', 'name', 'status']
    newArr = [newArr, ...csvData]

    setDisableCreateGroups(true)
    setConfirmCreateGroups(true)
    postEnrollmentsData(newArr)
  }

  const DialogUI = (
    open,
    titleText,
    bodyText,
    handleClose,
    handleConfirm,
    csvErrors,
    progress,
    confirmCreateGroups
  ) => {
    return (
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>{titleText}</DialogTitle>
        <DialogContent>
          <DialogContentText>
            {confirmCreateGroups === false ? bodyText : null}

            {confirmCreateGroups === true && progress != 100 ? (
              <div>
                {csvErrors.length !== 0 ? (
                  <p>Error</p>
                ) : (
                  <p>Creating.. Please wait</p>
                )}

                {csvErrors.join('</br>')}

                <LinearProgress
                  style={{ marginTop: 10 }}
                  variant='determinate'
                  value={progress}
                />
              </div>
            ) : null}

            {confirmCreateGroups === true && progress === 100 ? (
              <div>
                <p>Successfully Created.</p>
                <LinearProgress variant='determinate' value={progress} />
              </div>
            ) : null}
          </DialogContentText>
        </DialogContent>

        {confirmCreateGroups === false ? (
          <DialogActions>
            <Button autoFocus onClick={handleClose} color='primary'>
              Cancel
            </Button>
            <Button onClick={handleConfirm} color='primary'>
              Confirm
            </Button>
          </DialogActions>
        ) : (
          <DialogActions>
            <Button autoFocus onClick={handleClose} color='primary'>
              Done
            </Button>
          </DialogActions>
        )}
      </Dialog>
    )
  }

  const SelectDropDownUI = (key, dropDownCount, callback) => {
    let selectOptions = []

    for (let i = 0; i < dropDownCount; i++) {
      selectOptions.push(i)
    }

    let selectOptionsUI = selectOptions.map((data) => {
      return (
        <MenuItem key={`${key}-${data}`} value={data}>
          {data}
        </MenuItem>
      )
    })

    return (
      <Select
        labelId='demo-simple-select-outlined-label'
        id='demo-simple-select-outlined'
        label='Group Count'
        defaultValue={0}
        key={key}
        onChange={(event, newValue) => {
          callback(event, key)
        }}
      >
        {selectOptionsUI}
      </Select>
    )
  }

  const buttonOnCreateClick = () => {
    setDialogOpenCreateGroups(true)
    setCsvErrors([])
  }

  const onChangeReviewSwitch = (event) => {
    setEnableReviewGroupCategory(event.target.checked)
  }

  const buildCreateCategoryCSV = () => {
    let finalSectionName = sectionNames
    let finalGroupCount = groupCount
    let finalGroupCountEnd = groupCountEnd

    let enrollmentCSV = []
    let sisId = selectedCourse.sis_course_id
    // let finalGroupName = selectedGroupName;

    // let finalGroupCount = groupCount;
    let groupID = selectedGroupName

    for (let i = 0; i < finalSectionName.length; i++) {
      for (let k = finalGroupCount[i] - 1; k < finalGroupCountEnd[i]; k++) {
        let nameNumber = k + 1
        nameNumber = '' + nameNumber

        if (nameNumber.length === 1) {
          nameNumber = '0' + nameNumber
        }

        let shortGroupName = finalSectionName[i] + '-G' + nameNumber

        if (finalSectionName[i] !== '') {
          enrollmentCSV.push([
            groupID,
            groupID + '_' + shortGroupName,
            shortGroupName,
            'available'
          ])
        }
      }
    }

    // enrollmentCSV = enrollmentCSV.join('\n');
    // enrollmentCSV = JSON.stringify(enrollmentCSV)

    setCSVData(enrollmentCSV)
  }

  const buttonClickReview = () => {
    buildCreateCategoryCSV()
  }

  const buttonOnEnrollClick = () => {
    setDialogOpenEnroll(true)
    setCsvErrors([])
  }

  const onChangeReviewCsvSwitch = (event) => {
    setEnableReviewCsv(event.target.checked)
  }

  const onChangeTemplateCsvSwitch = (event) => {
    setEnableTemplateCsv(event.target.checked)
  }

  const [uploadCSVData, setUploadCSVData] = useState([])

  const upload = (e) => {
    const [file] = e.target.files || e.dataTransfer.files

    var reader = new FileReader()
    reader.onload = function (event) {
      // The file's text will be printed here

      let parseCsv = event.target.result.split('\n')

      setUploadCSVData(parseCsv)
    }

    reader.readAsText(file)
  }

  const [valueTabs, setValueTabs] = React.useState('one')

  const handleTabChange = (event, newValue) => {
    setValueTabs(newValue)
  }

  roles = [] //roles.filter(rows => includeRoles.includes(rows.id.toString()));

  // const optionsRoles = roles.map((option) => {
  //   const firstLetter =  option.label[0].toUpperCase();

  //   return {
  //     firstLetter: /[0-9]/.test(firstLetter) ? '0-9' : firstLetter,
  //     ...option,
  //   };
  // });

  const optionsRoles = []

  let top100Films = groupCategories.filter(
    (item) => item.sis_group_category_id !== null
  )

  const [progress, setProgress] = useState(10)
  const [sisImportID, setSisImportID] = useState(0)
  const [importedItemCounts, setImportedItemCounts] = useState(0)
  const [csvErrors, setCsvErrors] = useState([])
  const [errorAttachment, setErrorAttachment] = useState('')
  const [fileUploaded, setFileUploaded] = useState(false)
  const [textStatus, setTextStatus] = useState('')

  useEffect(() => {
    const interval = setInterval(async () => {
      if (fileUploaded && progress !== 100 && progress !== 0) {
        const sisStatus = await getSISImportStatus(sisImportID)

        let textStatus = ''
        let completed = 0

        if (sisStatus.workflow_state == 'importing') {
          textStatus = 'The request is currently processing.'
          completed = 70
        }

        if (sisStatus.workflow_state == 'imported') {
          textStatus =
            'The import is complete and all records were successfully imported.'
          completed = 100

          setImportedItemCounts(sisStatus.data.counts)
        }

        if (sisStatus.workflow_state == 'imported_with_messages') {
          textStatus = 'CSV error'
          completed = 0

          setCsvErrors(sisStatus.processing_warnings)
          setErrorAttachment(sisStatus.errors_attachment.url)
        }

        if (sisStatus.workflow_state == 'failed_with_messages') {
          textStatus = 'CSV error'
          completed = 0

          setCsvErrors(sisStatus.processing_errors)
          setErrorAttachment(sisStatus.errors_attachment.url)
        }

        setProgress(completed)
        setTextStatus(textStatus)
      }
    }, 2000)
    return () => clearInterval(interval)
  }, [sisImportID, progress])

  useEffect(() => {
    if (sis_status.data.length !== 0) {
      let json = sis_status.data[0]

      if (json.workflow_state === 'created') {
        setSisImportID(json.id)
        setFileUploaded(true)
        setProgress(20)
        setTextStatus('The request has been created')
      }
    }
  }, [sis_status])

  return (
    <div>
      <Dialog
        key='ddd'
        fullScreen
        open={fullPageModel}
        onClose={handleClose}
        TransitionComponent={Transition}
      >
        <AppBar className={classes.appBar}>
          <Toolbar>
            <IconButton
              edge='start'
              color='inherit'
              onClick={handleClose}
              aria-label='close'
            >
              <CloseIcon />
            </IconButton>
            <Typography variant='h6' className={classes.title}>
              {title}
            </Typography>

            <Typography variant='span' className={classes.title}>
              {subTitle}
            </Typography>
            {/* <Button autoFocus color="inherit" onClick={handleSave}>
              Close
            </Button> */}
          </Toolbar>
        </AppBar>

        <div className={classes.root}>
          <Paper className={classes.root}>
            <Tabs
              value={valueTabs}
              onChange={handleTabChange}
              indicatorColor='primary'
              textColor='primary'
              variant='fullWidth'
              centered
            >
              <Tab value='one' label='Create Groups' {...a11yProps('one')} />
              {/* <Tab value="two" label="Manage Groups" {...a11yProps('two')} />
              <Tab value="three" label="Statistic" {...a11yProps('three')} /> */}
            </Tabs>

            <TabPanel className={classes.theme} value={valueTabs} index='one'>
              <br />
              <br />

              <Grid container justify='center' alignItems='center' spacing={3}>
                <Grid item xs={7}>
                  <div className={classes.root}>
                    <Accordion>
                      <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls='panel1a-content'
                        id='create-group-category'
                      >
                        <Typography className={classes.heading}>
                          Create Group Category
                        </Typography>
                      </AccordionSummary>
                      <AccordionDetails>
                        <Grid item xs={12}>
                          {groupCategories.length !== 0 ? (
                            <p>
                              <strong>Existing Group Categories:</strong>{' '}
                              {groupCategories.map((item) => `${item.name},`)}
                            </p>
                          ) : null}

                          <TextField
                            fullWidth
                            id='outlined-required'
                            label='Group Category Name'
                            variant='outlined'
                            onChange={onChangeGroupCategory}
                          />

                          <br />
                          <br />
                          <Button
                            variant='contained'
                            color='primary'
                            disabled={
                              groupCreated !== 'NEW' || groupName.trim() === ''
                            }
                            onClick={onClickCreateGroupCategory}
                          >
                            Create &nbsp;{' '}
                            {groupCreated === 'CREATING' ? (
                              <CircularProgress color='inherit' size={20} />
                            ) : null}
                          </Button>

                          <span style={{ color: '#015548' }}>
                            {' '}
                            {groupCreated === 'CREATED'
                              ? 'Group Created'
                              : null}
                          </span>

                          <span style={{ color: '#ef0b0b' }}>
                            {' '}
                            {groupCreated === 'ERROR_NAME'
                              ? 'Group name already existing.'
                              : null}
                          </span>
                        </Grid>
                      </AccordionDetails>
                    </Accordion>
                  </div>

                  <br />
                  <br />

                  <Accordion>
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls='create-group-content'
                      id='create-group'
                    >
                      <Typography className={classes.heading}>
                        Create Groups (G01,G02 etc)
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Grid container>
                        <Grid container spacing={1}>
                          <Grid item xs={10}>
                            <Autocomplete
                              id='combo-box-demo'
                              options={top100Films}
                              disabled={disableCreateGroups}
                              getOptionLabel={(option) => `${option.name}`}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  label='Group Category'
                                  variant='outlined'
                                />
                              )}
                              onChange={(event, newValue) => {
                                onChangeSelectedGroupName(event, newValue)
                              }}
                            />{' '}
                          </Grid>
                          <Grid item xs={2}>
                            <Button
                              disabled={disableCreateGroups}
                              onClick={loadCategories}
                              variant='outlined'
                            >
                              {' '}
                              <Icon style={{ fontSize: 40 }} color='primary'>
                                refresh
                              </Icon>
                            </Button>
                          </Grid>
                        </Grid>

                        {dynamicGroupCategoryCount.map((data) => {
                          let Ui = (
                            <Grid
                              style={{ marginTop: 8 }}
                              key={`my-${data}`}
                              container
                              spacing={5}
                            >
                              <Grid item xs={4}>
                                <TextField
                                  fullWidth
                                  id='outlined-required'
                                  disabled={disableCreateGroups}
                                  label='Group Prefix'
                                  defaultValue=''
                                  variant='outlined'
                                  onChange={(event, newValue) => {
                                    onChangeSectionNames(event, data)
                                  }}
                                />
                              </Grid>

                              <Grid item xs={3}>
                                <FormControl
                                  disabled={disableCreateGroups}
                                  variant='outlined'
                                  fullWidth
                                  className={classes.margin}
                                >
                                  <InputLabel id='demo-simple-select-outlined-label'>
                                    Group Start
                                  </InputLabel>
                                  {SelectDropDownUI(
                                    'select' + data,
                                    generateSelectOptionCount,
                                    onGroupCount
                                  )}
                                </FormControl>
                              </Grid>

                              <Grid item xs={3}>
                                <FormControl
                                  disabled={disableCreateGroups}
                                  variant='outlined'
                                  fullWidth
                                  className={classes.margin}
                                >
                                  <InputLabel id='demo-simple-select-outlined-label'>
                                    Group end
                                  </InputLabel>
                                  {SelectDropDownUI(
                                    'select-end' + data,
                                    generateSelectOptionCount,
                                    onGroupCountEnd
                                  )}
                                </FormControl>
                              </Grid>

                              <Grid item xs={1}>
                                <Button
                                  disabled={disableCreateGroups}
                                  onClick={onClickGroupElementCreate}
                                  variant='outlined'
                                >
                                  <Icon
                                    style={{ fontSize: 20 }}
                                    color='primary'
                                  >
                                    add
                                  </Icon>
                                </Button>

                                {data === dynamicGroupCategoryCount.length &&
                                dynamicGroupCategoryCount.length !== 1 ? (
                                  <Button
                                    disabled={disableCreateGroups}
                                    onClick={onClickGroupElementRemove}
                                    variant='outlined'
                                  >
                                    <Icon
                                      style={{ fontSize: 20 }}
                                      color='primary'
                                    >
                                      remove
                                    </Icon>
                                  </Button>
                                ) : null}
                              </Grid>
                            </Grid>
                          )

                          return Ui
                        })}

                        <div
                          style={{ marginTop: 20 }}
                          className={classes.pullLeft}
                        >
                          <Button
                            disabled={
                              disableCreateGroups === true ||
                              csvData.length === 0 ||
                              selectedGroupName === ''
                            }
                            variant='contained'
                            color='primary'
                            style={{ marginRight: 10 }}
                            onClick={buttonOnCreateClick}
                          >
                            {' '}
                            Create Groups
                          </Button>

                          <FormControlLabel
                            control={
                              <Switch
                                checked={enableReviewGroupCategory}
                                onChange={onChangeReviewSwitch}
                                name='checkedB'
                                color='primary'
                              />
                            }
                            label='Simulate Groups'
                          />

                          {/* <Button
    variant="contained"
    color="primary"
    style={{ marginRight: 10 }}
    onClick={buttonClickReview}> Review Groups
  </Button> */}
                        </div>

                        {enableReviewGroupCategory === true &&
                        csvData.length !== 0 ? (
                          <TableContainer component={Paper}>
                            <Table
                              className={classes.table}
                              aria-label='simple table'
                            >
                              <TableHead>
                                <TableRow>
                                  <TableCell>SIS ID</TableCell>
                                  <TableCell align='right'>
                                    Group SIS ID
                                  </TableCell>
                                  <TableCell align='right'>
                                    Group Name
                                  </TableCell>
                                  <TableCell align='right'>Status</TableCell>
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {csvData.map((row) => (
                                  <TableRow key={row}>
                                    <TableCell align='right'>
                                      {row[0]}
                                    </TableCell>
                                    <TableCell align='right'>
                                      {row[1]}
                                    </TableCell>
                                    <TableCell align='right'>
                                      {row[2]}
                                    </TableCell>
                                    <TableCell align='right'>
                                      {row[3]}
                                    </TableCell>
                                  </TableRow>
                                ))}
                              </TableBody>
                            </Table>
                          </TableContainer>
                        ) : null}
                      </Grid>
                    </AccordionDetails>
                  </Accordion>

                  <br />
                  <br />

                  <Accordion>
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls='enroll-users-content'
                      id='enroll-users'
                    >
                      <Typography className={classes.heading}>
                        Enroll Users
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Grid container spacing={3}>
                        <Grid item xs={12}>
                          <div
                            style={{ marginTop: 20 }}
                            className={classes.pullLeft}
                          >
                            <FormControlLabel
                              style={{ marginTop: 20, marginLeft: 10 }}
                              control={
                                <Switch
                                  checked={enableTemplateCsv}
                                  onChange={onChangeTemplateCsvSwitch}
                                  name='checkedCsv'
                                  color='primary'
                                />
                              }
                              label='View Sample CSV file Format'
                            />

                            <TableContainer
                              hidden={!enableTemplateCsv}
                              component={Paper}
                            >
                              <Table
                                className={classes.table}
                                aria-label='simple table'
                              >
                                <TableHead>
                                  <TableRow>
                                    <TableCell>Name</TableCell>
                                    <TableCell align='right'>
                                      Download
                                    </TableCell>
                                  </TableRow>
                                </TableHead>
                                <TableBody>
                                  {csvTemplates.map((row) => (
                                    <TableRow key={row.name}>
                                      <TableCell component='th' scope='row'>
                                        {row.name}
                                      </TableCell>
                                      <TableCell align='right'>
                                        <Button
                                          variant='contained'
                                          color='default'
                                          href={
                                            downloadPath +
                                            'csv-templates/' +
                                            row.downloadLink
                                          }
                                        >
                                          <GetAppIcon />
                                        </Button>
                                      </TableCell>
                                    </TableRow>
                                  ))}
                                </TableBody>
                              </Table>
                            </TableContainer>

                            <br />
                            <Divider variant='middle' />
                            <br />

                            <form>
                              <input
                                style={{ display: 'none' }}
                                id='csv_file_input_category'
                                className='button'
                                type='file'
                                accept='.csv'
                                onChange={upload}
                              />

                              <label
                                className='MuiButtonBase-root MuiButton-root MuiButton-contained makeStyles-button-27 '
                                htmlFor='csv_file_input_category'
                              >
                                Select Csv File <DescriptionIcon />{' '}
                              </label>

                              <FormControlLabel
                                style={{ marginTop: 20, marginLeft: 10 }}
                                control={
                                  <Switch
                                    checked={enableReviewCsv}
                                    onChange={onChangeReviewCsvSwitch}
                                    name='checkedCsv'
                                    color='primary'
                                  />
                                }
                                label='Simulate Selected Csv'
                              />
                            </form>
                          </div>

                          <br />
                          <Divider variant='middle' />
                          <br />
                          <Button
                            disabled={uploadCSVData.length === 0}
                            variant='contained'
                            color='primary'
                            style={{ marginRight: 10 }}
                            onClick={buttonOnEnrollClick}
                          >
                            {' '}
                            Enroll Users
                          </Button>

                          {uploadCSVData.length === 0
                            ? 'Please select a file to enable enroll button'
                            : null}
                        </Grid>

                        <Grid item xs={12}>
                          {uploadCSVData.length !== 0 &&
                          enableReviewCsv === true ? (
                            <TableContainer fullWidth component={Paper}>
                              <Table
                                size='small'
                                className={classes.table}
                                aria-label='simple table'
                              >
                                <TableBody>
                                  {uploadCSVData.map((row) => (
                                    <TableRow key={row}>
                                      {row.split(',').map((data) => (
                                        <TableCell align='right'>
                                          {data}
                                        </TableCell>
                                      ))}
                                    </TableRow>
                                  ))}
                                </TableBody>
                              </Table>
                            </TableContainer>
                          ) : null}
                        </Grid>
                      </Grid>
                    </AccordionDetails>
                  </Accordion>
                </Grid>
              </Grid>
            </TabPanel>
          </Paper>
        </div>

        {DialogUI(
          dialogOpenCreateGroups,
          'Create Groups',
          'Before click on the confirm button, please check the simulation table to verify Groups.',
          dialogCreateOnClose,
          dialogCreateOnConfirm,
          csvErrors,
          progress,
          confirmCreateGroups
        )}

        {DialogUI(
          dialogOpenEnroll,
          'Enroll Users to groups',
          'Before click on the confirm button, please check the simulation csv to verify Groups and users.',
          dialogEnrollOnClose,
          dialogEnrollOnConfirm,
          csvErrors,
          progress,
          confirmEnrollUsers
        )}
      </Dialog>
    </div>
  )
}

function mapStateToProps(state) {
  return {
    courseSectionData: state.CourseLevelAdmin.courseSection,
    courseSectionUserData: state.CourseLevelAdmin.courseSectionUserData,
    rolesData: state.CourseLevelAdmin.roles.data,
    csvActionType: state.CourseLevelAdmin.csvActionType,

    selectedCoursesList: state.CourseLevelAdmin.summery.courses,
    sis_status: state.CourseLevelAdmin.sis_status
  }
}

export default connect(mapStateToProps, {
  clearSummeryCourses,
  loadProgrammesData,
  loadRolesData,
  updateCsvAction,
  updateSectionUserData,
  loadSectionData,
  updateSetupProgress,
  updateSummeryUserEmailList,
  postEnrollmentsData
})(FullScreenDialog)
